import React from "react";


export default function Members() {
  return (
    <div className="py-20 bg-white">
      <div className="w-11/12 mx-auto 2xl:max-w-[1200px]">
        <h1 className="f-f-r-s font-semibold text-center text-grey-dark text-9xl">
          {" "}
          <span className="text-green-dark"> Our</span> Team Members
        </h1>
        <p className="f-f-r-s text-lg text-green-dark text-center mt-[14px]">
          Welcome to the heart and soul of Rapido Relief! Our team is a
          dedicated group of individuals driven by a shared passion for
          revolutionizing healthcare and making a meaningful impact on people's
          lives. Get to know the faces behind the mission as we introduce you to
          the talented individuals who make it all happen:
        </p>

        <div className="grid grid-cols-12 gap-6 md:gap-12 xl:gap-[75px] mt-14">
          <div className="col-span-12 sm:col-span-6 xl:col-span-4">
            <div className="px-7 pb-[26px] bg-green-dark rounded-b-[25px]">
              <img
                src="/images/image 29.svg"
                className=" rounded-b-[25px] w-full h-[215px]" alt=""
              />
              <h2 className="mt-4 f-f-r-s font-semibold text-white text-center text-xl uppercase  ">
                Michael Tosin Adesanwo
              </h2>

              <div className="text-center">
                <button className="Memberbutton w-[157px] h-11 border border-green f-f-r-s text-lg text-white rounded-[100px] mt-4">
                  CEO / Founder
                </button>
              </div>
              <div className="text-center mt-3 xl:mt-0">
                <ul className="inline-flex mt-[15px] space-x-2 md:space-x-4 items-center">
                  <li>
                    <button className="socialbtn rounded-[66px] border border-grey-dark w-[52px] h-[52px] p-4">
                      <img
                        src="/images/facebook.svg"
                        className="w-5 h-5"
                        alt=""
                      />
                    </button>
                  </li>
                  <li>
                    <button className="socialbtn rounded-[66px] border border-grey-dark w-[52px] h-[52px] p-4">
                      <img
                        src="/images/instagraram.svg"
                        className="w-5 h-5"
                        alt=""
                      />
                    </button>
                  </li>
                  <li>
                    <button className="socialbtn rounded-[66px] border border-grey-dark w-[52px] h-[52px] p-4">
                      <img
                        src="/images/Vectorx.svg"
                        className="w-5 h-5"
                        alt=""
                      />
                    </button>
                  </li>
                  <li>
                    <a
                      href="https://www.linkedin.com/in/sergio-maciel-kronardt-724033a/"
                      className="socialbtn inline-block mt-2 rounded-[66px] border border-grey-dark w-[52px] h-[52px] p-4"
                    >
                      <img
                        src="/images/linkedin.svg"
                        className="w-5 h-5"
                        alt=""
                      />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-span-12 sm:col-span-6 xl:col-span-4">
            <div className="px-7 pb-[26px] bg-green-dark rounded-b-[25px]">
              {/* <div className="bg-red-light rounded-b-[25px] w-full h-[215px]">
               
              </div> */}
              <img
                src="/images/image 30.svg"
                className=" rounded-b-[25px] w-full h-[215px] " alt=""
              />
              <h2 className="mt-4 f-f-r-s font-semibold text-white text-center text-xl uppercase  ">
                Isa Mariana Afonso Bigi
              </h2>

              <div className="text-center">
                <button className="Memberbutton w-[202px] h-11 border border-green f-f-r-s text-lg text-white rounded-[100px] mt-4">
                  Web/Content Manager
                </button>
              </div>
              <div className="text-center mt-3 xl:mt-0">
                <ul className="inline-flex mt-[15px] space-x-2 md:space-x-4 items-center">
                  <li>
                    <button className="socialbtn rounded-[66px] border border-grey-dark w-[52px] h-[52px] p-4">
                      <img
                        src="/images/facebook.svg"
                        className="w-5 h-5"
                        alt=""
                      />
                    </button>
                  </li>
                  <li>
                    <button className="socialbtn rounded-[66px] border border-grey-dark w-[52px] h-[52px] p-4">
                      <img
                        src="/images/instagraram.svg"
                        className="w-5 h-5"
                        alt=""
                      />
                    </button>
                  </li>
                  <li>
                    <button className="socialbtn rounded-[66px] border border-grey-dark w-[52px] h-[52px] p-4">
                      <img
                        src="/images/Vectorx.svg"
                        className="w-5 h-5"
                        alt=""
                      />
                    </button>
                  </li>
                  <li>
                    <a
                      href="https://www.linkedin.com/in/isamarianaafonso/"
                      className="socialbtn inline-block mt-2 rounded-[66px] border border-grey-dark w-[52px] h-[52px] p-4"
                    >
                      <img
                        src="/images/linkedin.svg"
                        className="w-5 h-5"
                        alt=""
                      />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-span-12 sm:col-span-6 xl:col-span-4">
            <div className="px-7 pb-[26px] bg-green-dark rounded-b-[25px]">
              <div className="bg-red-light rounded-b-[25px] w-full h-[215px]"></div>
              <h2 className="mt-4 f-f-r-s font-semibold text-white text-center text-xl uppercase  ">
                FULL NAME
              </h2>

              <div className="text-center">
                <button className="Memberbutton w-[157px] h-11 border border-green f-f-r-s text-lg text-white rounded-[100px] mt-4">
                  Project Manager
                </button>
              </div>
              <div className="text-center mt-3 xl:mt-0">
                <ul className="inline-flex mt-[15px] space-x-2 md:space-x-4 items-center">
                  <li>
                    <button className="socialbtn rounded-[66px] border border-grey-dark w-[52px] h-[52px] p-4">
                      <img
                        src="/images/facebook.svg"
                        className="w-5 h-5"
                        alt=""
                      />
                    </button>
                  </li>
                  <li>
                    <button className="socialbtn rounded-[66px] border border-grey-dark w-[52px] h-[52px] p-4">
                      <img src="/images/instagraram.svg" className="w-5 h-5" alt="" />
                    </button>
                  </li>
                  <li>
                    <button className="socialbtn rounded-[66px] border border-grey-dark w-[52px] h-[52px] p-4">
                      <img src="/images/Vectorx.svg" className="w-5 h-5" alt="" />
                    </button>
                  </li>
                  <li>
                    <a
                      href="#"
                      className="socialbtn inline-block mt-2 rounded-[66px] border border-grey-dark w-[52px] h-[52px] p-4"
                    >
                      <img src="/images/linkedin.svg" className="w-5 h-5" alt="" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-span-12 sm:col-span-6 xl:col-span-4">
            <div className="px-7 pb-[26px] bg-green-dark rounded-b-[25px]">
              <div className="bg-red-light rounded-b-[25px] w-full h-[215px]"></div>
              <h2 className="mt-4 f-f-r-s font-semibold text-white text-center text-xl uppercase  ">
                {" "}
                FULL NAME
              </h2>

              <div className="text-center">
                <button className="Memberbutton w-[157px] h-11 border border-green f-f-r-s text-lg text-white rounded-[100px] mt-4">
                  CTO Personnel
                </button>
              </div>
              <div className="text-center mt-3 xl:mt-0">
                <ul className="inline-flex mt-[15px] space-x-2 md:space-x-4 items-center">
                  <li>
                    <button className="socialbtn rounded-[66px] border border-grey-dark w-[52px] h-[52px] p-4">
                      <img src="/images/facebook.svg" className="w-5 h-5" alt="" />
                    </button>
                  </li>
                  <li>
                    <button className="socialbtn rounded-[66px] border border-grey-dark w-[52px] h-[52px] p-4">
                      <img src="/images/instagraram.svg" className="w-5 h-5" alt="" />
                    </button>
                  </li>
                  <li>
                    <button className="socialbtn rounded-[66px] border border-grey-dark w-[52px] h-[52px] p-4">
                      <img src="/images/Vectorx.svg" className="w-5 h-5" alt="" />
                    </button>
                  </li>
                  <li>
                    <button className="socialbtn rounded-[66px] border border-grey-dark w-[52px] h-[52px] p-4">
                      <img src="/images/linkedin.svg" className="w-5 h-5" alt="" />
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-span-12 sm:col-span-6 xl:col-span-4">
            <div className="px-7 pb-[26px] bg-green-dark rounded-b-[25px]">
              <div className="bg-red-light rounded-b-[25px] w-full h-[215px]"></div>
              <h2 className="mt-4 f-f-r-s font-semibold text-white text-center text-xl uppercase  ">
                FULL NAME
              </h2>

              <div className="text-center">
                <button className="Memberbutton w-[157px] h-11 border border-green f-f-r-s text-lg text-white rounded-[100px] mt-4">
                  MTK Manager
                </button>
              </div>
              <div className="text-center mt-3 xl:mt-0">
                <ul className="inline-flex mt-[15px] space-x-2 md:space-x-4 items-center">
                  <li>
                    <button className="socialbtn rounded-[66px] border border-grey-dark w-[52px] h-[52px] p-4">
                      <img src="/images/facebook.svg" className="w-5 h-5" alt="" />
                    </button>
                  </li>
                  <li>
                    <button className="socialbtn rounded-[66px] border border-grey-dark w-[52px] h-[52px] p-4">
                      <img src="/images/instagraram.svg" className="w-5 h-5" alt="" />
                    </button>
                  </li>
                  <li>
                    <button className="socialbtn rounded-[66px] border border-grey-dark w-[52px] h-[52px] p-4">
                      <img src="/images/Vectorx.svg" className="w-5 h-5" alt="" />
                    </button>
                  </li>
                  <li>
                    <button className="socialbtn rounded-[66px] border border-grey-dark w-[52px] h-[52px] p-4">
                      <img src="/images/linkedin.svg" className="w-5 h-5" alt="" />
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-span-12 sm:col-span-6 xl:col-span-4">
            <div className="px-7 pb-[26px] bg-green-dark rounded-b-[25px]">
              {/* <div className="bg-red-light rounded-b-[25px] w-full h-[215px]">
               
              </div> */}
              <img
                src="/images/images 31.svg"
                className=" rounded-b-[25px] w-full h-[215px]" alt=""
              />

              <h2 className="mt-4 f-f-r-s font-semibold text-white text-center text-xl uppercase  ">
                Sergio Maciel
              </h2>

              <div className="text-center">
                <button className="Memberbutton w-[163px] h-11 border border-green f-f-r-s text-lg text-white rounded-[100px] mt-4">
                  Advisor & Mentor
                </button>
              </div>
              <div className="text-center mt-3 xl:mt-0">
                <ul className="inline-flex mt-[15px] space-x-2 md:space-x-4 items-center">
                  <li>
                    <button className="socialbtn rounded-[66px] border border-grey-dark w-[52px] h-[52px] p-4">
                      <img src="/images/facebook.svg" className="w-5 h-5" alt="" />
                    </button>
                  </li>
                  <li>
                    <button className="socialbtn rounded-[66px] border border-grey-dark w-[52px] h-[52px] p-4">
                      <img src="/images/instagraram.svg" className="w-5 h-5" alt="" />
                    </button>
                  </li>
                  <li>
                    <button className="socialbtn rounded-[66px] border border-grey-dark w-[52px] h-[52px] p-4">
                      <img src="/images/Vectorx.svg" className="w-5 h-5" alt="" />
                    </button>
                  </li>
                  <li>
                    <a
                      href="https://www.linkedin.com/in/isamarianaafonso/"
                      className="socialbtn inline-block mt-2 rounded-[66px] border border-grey-dark w-[52px] h-[52px] p-4"
                    >
                      <img src="/images/linkedin.svg" className="w-5 h-5" alt="" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
